





















































































































































































import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'
import '@/apps/exam/views/topicgroup/components/reset.scss'
import CreateTopicPart from '@/apps/exam/views/topicgroup/components/CreateTopicPart.vue'
import RandomCreateTopic from '@/apps/exam/views/topicgroup/components/RandomCreateTopic.vue'
import RandomCreateTopic1 from '@/apps/exam/views/topicgroup/components/RandomCreateTopic1.vue'

import FixedCreaTopic from '@/apps/exam/views/topicgroup/components/FixedCreaTopic.vue'
import { addRemark, getTopicGroup } from '@/api/exam/topicGroup'
import { YKDCenterDrawer } from 'gum-ui'
import {
  saveTopicPart,
  queryTopicPart,
  deleteTopicPart,
  getTopicPart
} from '@/api/exam/topicGroup'
import { sort } from '@/api/exam/topicGroup'
import { getDurations } from './config'
import 'normalize.css/normalize.css'
import { Company } from 'ykd-base/account'
import { message } from 'ant-design-vue'
const TopicPart = namespace('app-exam/topicPart')
@Component({
  components: {
    CreateTopicPart,
    RandomCreateTopic,
    FixedCreaTopic,
    YKDCenterDrawer,
    RandomCreateTopic1
  }
})
export default class CreateTopicPartList extends Vue {
  @Prop() private topicGroupId?: string
  @TopicPart.State('topicParts') topicParts!: TopicPart[]
  @TopicPart.Action('queryTopicPart') queryTopicPart!: Function
  @TopicPart.Action('deleteTopicPartData') deleteTopicPartData!: Function
  @TopicPart.Action('editExamPlan') editExamPlan!: Function
  @TopicPart.Action('topicPartSort') topicPartSort!: Function
  private durations: any[] = getDurations()
  private deleteTopicPartVisible: boolean = false
  private randomCreateTopicVisible: boolean = false
  private fixedCreaTopicVisible: boolean = false
  private sortVisible: Boolean = false
  private ulVisible: Boolean = false
  private buttonVisible: string = ''
  private titlePadding: string = ''
  private listVisible: Boolean = false
  private departmentList: any = []
  private editorSorting: boolean = false
  private visible: Boolean = false
  private orignalIndex: number = 0
  private adjustIndex: number = 0
  private maxIndex: number = 0
  private localTopicPart: TopicPart = {}
  private localEditTopicPart: TopicPart = {}
  private createTopicPartVisable: boolean = false
  private totalTopicNumber: number = 0
  private totalTopicGroupScore: number = 0
  private deTopicPartData: TopicPart = {}
  //新添加的代码
  private topicGroup: TopicGroup = {}
  closeDeleteTopicPart() {
    this.deleteTopicPartVisible = false
  }
  openDeleteTopicPart() {
    this.deleteTopicPartVisible = true
  }
  async confirmDelete() {
    this.deleteTopicPartVisible = false
    console.log(this.deTopicPartData.id, 'ccccccccccc')
    await this.deleteTopicPartData(this.deTopicPartData.id)
    //计算总题数试卷总分
    this.totalTopicNumber =
      this.totalTopicNumber - this.deTopicPartData!.topicNumber!
    this.totalTopicGroupScore =
      this.totalTopicGroupScore -
      this.deTopicPartData!.topicNumber! * this.deTopicPartData!.everyScore!
  }
  async deleteTopicPart(item: any) {
    //先查询一下该分组有没有题目

    this.deleteTopicPartVisible = true
    this.deTopicPartData = item
  }
  getCreatetTopicType(random: boolean) {
    if (random) {
      return '随机出题'
    } else {
      return '固定出题'
    }
  }
  async save() {
    await sort({ topicParts: this.topicParts })
    this.$message.success('保存成功')
    this.sortVisible = false
    this.titlePadding = ''
  }
  async blur(text: string, index: number, sort: string) {
    await addRemark(this.topicGroup)
    this.$message.success('添加评语成功')
  }
  addRemark() {
    Vue.set(this.topicGroup!, 'remarks', [
      ...(this.topicGroup!.remarks! || []),
      {
        startScore: '',
        endScore: '',
        remark: ''
      }
    ])
  }
  deleteRemark(index: number) {
    if (index != 0) {
      this.topicGroup!.remarks!.splice(index, 1)
      addRemark(this.topicGroup)
      this.$message.success('保存评语成功')
    } else {
      this.$message.success('请至少有一条评语')
    }
  }
  private adjustTopicPartSort(orignalIndex: number, adjustIndex: number) {
    if (adjustIndex === -1) {
      adjustIndex = 0
      return
    }
    if (adjustIndex > this.topicParts.length - 1) {
      adjustIndex = this.topicParts.length
      return
    }
    this.topicPartSort([orignalIndex, adjustIndex])
    this.$forceUpdate()
  }
  closeRandomCreateTopic() {
    this.randomCreateTopicVisible = false
  }
  closeFixedCreaTopic() {
    this.fixedCreaTopicVisible = false
  }
  //出题
  createTopic(item: any) {
    this.localTopicPart = item
    //判断是随机出题还是固定出题
    if (item.randomCreate) {
      //随机出题
      this.randomCreateTopicVisible = true
    } else {
      //固定出题
      this.fixedCreaTopicVisible = true
    }
  }
  //添加分组
  addTopicPart() {
    this.localTopicPart = {}
    this.createTopicPartVisable = true
  }

  //编辑分组
  async editTopicPart(item: any) {
    this.localTopicPart = item
    this.localEditTopicPart = item
    this.createTopicPartVisable = true
  }
  closeCreateTopicPart() {
    this.createTopicPartVisable = false
  }
  confirmCreateTopicPart(topicPart: TopicPart, isEdit: boolean) {
    this.createTopicPartVisable = false
    if (isEdit) {
      this.totalTopicNumber += Number(topicPart.topicNumber!)
      this.totalTopicGroupScore +=
        Number(topicPart.everyScore!) * Number(topicPart.topicNumber!)
    } else {
      this.totalTopicNumber = 0
      this.totalTopicGroupScore = 0
      this.topicParts.forEach((item, index) => {
        this.totalTopicNumber += item.topicNumber!
        this.totalTopicGroupScore +=
          Number(item.everyScore!) * Number(item.topicNumber!)
      })
    }
  }
  @Watch('topicParts')
  ontopicPartChange() {
    this.inieSelect()
  }
  inieSelect() {
    if (this.topicParts) {
      this.maxIndex = this.topicParts.length - 1
    } else {
      this.maxIndex = 0
      this.listVisible = true
      this.ulVisible = false
    }
    var outerContainerHeight = (this.$refs.scrollData as HTMLElement)
      .clientHeight
    var ulHeight = (this.$refs.ulHeight as HTMLElement).clientHeight
    const justifyVisible =
      ulHeight - outerContainerHeight < 0 && this.topicParts
    if (justifyVisible) {
      this.listVisible = false
    }
    ;(this.$refs.scrollData as HTMLElement).addEventListener('scroll', () => {
      var intElemScrollTop = (this.$refs.scrollData as HTMLElement).scrollTop
      if (ulHeight - outerContainerHeight == intElemScrollTop) {
        this.ulVisible = true
        this.listVisible = false
      }
    })
    if (this.topicParts && this.topicParts.length < 10) {
      this.ulVisible = false
    }
  }
  async mounted() {
    this.inieSelect()
    //获取总题数
    this.topicGroup = await getTopicGroup(this.topicGroupId!)
    //获取试卷总分
    if (this.topicParts && this.topicParts.length > 0) {
      this.topicParts.forEach((item, index) => {
        this.totalTopicNumber += Number(item.topicNumber!)
        this.totalTopicGroupScore +=
          Number(item.everyScore!) * Number(item.topicNumber!)
      })
    }
  }

  /**
   * 取消保存部门数据
   */
  private cancel() {
    this.titlePadding = ''
    this.sortVisible = false
    message.info('取消成功！')
  }

  // private addParentDepartment() {
  //   ;(this.$refs.addDepartment as AddDepartment).showModal()
  //   this.setDepartment(this.department)
  // }
  private adjustSort() {
    this.titlePadding = 'padding-left:68px'
    this.sortVisible = true
  }
}
